import { register } from 'register-service-worker'

if (process.env.NODE_ENV === 'production') {
  register(`${process.env.BASE_URL}service-worker.js`, {
    ready() {
      console.log('[SW] App is being served from cache by a service worker.')
    },
    registered() {
      console.log('[SW] Service worker has been registered.')
    },
    cached() {
      console.log('[SW] Content has been cached for offline use.')
    },
    updatefound() {
      console.log('[SW] New content is downloading.')
    },
    updated(registration) {
      console.log('[SW] New content is available; please refresh.')
      if (confirm('Nuova versione disponibile. Aggiornare?')) {
        registration.waiting?.postMessage({ type: 'SKIP_WAITING' })
        window.location.reload()
      }
    },
    offline() {
      console.log('[SW] No internet connection found. App is running in offline mode.')
    },
    error(error) {
      console.error('[SW] Error during service worker registration:', error)
    },
  })
}
